import { TableHead, TableRow } from '@mui/material'
import React from 'react'
import { StyledTableCell } from 'shared/components/Table'

export const ListHeader = () => {
    return (
        <TableHead>
            <TableRow>
                <StyledTableCell align='center' sx={{ width: 50 }}>NO</StyledTableCell>
                <StyledTableCell align='center' sx={{ width: 150 }}>NIP</StyledTableCell>
                <StyledTableCell align='center'>NAMA</StyledTableCell>
                <StyledTableCell align='center' sx={{ width: 300 }}>UNIT KERJA</StyledTableCell>
                <StyledTableCell align='center' sx={{ width: 300 }}>SATUAN KERJA</StyledTableCell>
            </TableRow>
        </TableHead>
    )
}